"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var home_scss_1 = __importDefault(require("./home.scss"));
var Home = function () { return (preact_1.h("div", { class: home_scss_1.default.home },
    preact_1.h("h1", null, "Home"),
    preact_1.h("p", null, "This is the Home component."))); };
exports.default = Home;
//# sourceMappingURL=home.js.map


// WEBPACK FOOTER //
// ./routes/home/home.js